<template>
  <router-view/>
</template>

<script>

export default {
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main/layout/index.vue